// Generated for Lote 1 (AJUSTE 003a, plano §2.3): maps every literal English string
// bpmn-js core (context pad/replace menu) and bpmn-js-create-append-anything can pass to the
// injected diagram-js `translate` service to a fluss.* key, so flussTranslate() in
// FlussCanvas.tsx can localize them via react-i18next. Keys not present here fall back to the
// raw English string (never blank, never crashes) — see flussTranslate's lookup.
export const FLUSS_BPMN_LABEL_KEYS: Record<string, string> = {
    "Events": "fluss.canvas.bpmn.group.events",
    "Tasks": "fluss.canvas.bpmn.group.tasks",
    "Data": "fluss.canvas.bpmn.group.data",
    "Sub-processes": "fluss.canvas.bpmn.group.sub_processes",
    "Gateways": "fluss.canvas.bpmn.group.gateways",
    "Create element": "fluss.canvas.bpmn.title.create_element",
    "Append element": "fluss.canvas.bpmn.title.append_element",
    "Boundary event": "fluss.canvas.bpmn.element.boundary_event",
    "Business rule task": "fluss.canvas.bpmn.element.business_rule_task",
    "Call activity": "fluss.canvas.bpmn.element.call_activity",
    "Cancel boundary event": "fluss.canvas.bpmn.element.cancel_boundary_event",
    "Cancel end event": "fluss.canvas.bpmn.element.cancel_end_event",
    "Compensation boundary event": "fluss.canvas.bpmn.element.compensation_boundary_event",
    "Compensation end event": "fluss.canvas.bpmn.element.compensation_end_event",
    "Compensation intermediate throw event": "fluss.canvas.bpmn.element.compensation_intermediate_throw_event",
    "Compensation start event": "fluss.canvas.bpmn.element.compensation_start_event",
    "Complex gateway": "fluss.canvas.bpmn.element.complex_gateway",
    "Conditional boundary event (non-interrupting)": "fluss.canvas.bpmn.element.conditional_boundary_event_non_interrupting",
    "Conditional boundary event": "fluss.canvas.bpmn.element.conditional_boundary_event",
    "Conditional flow": "fluss.canvas.bpmn.element.conditional_flow",
    "Conditional intermediate catch event": "fluss.canvas.bpmn.element.conditional_intermediate_catch_event",
    "Conditional start event (non-interrupting)": "fluss.canvas.bpmn.element.conditional_start_event_non_interrupting",
    "Conditional start event": "fluss.canvas.bpmn.element.conditional_start_event",
    "Data object reference": "fluss.canvas.bpmn.element.data_object_reference",
    "Data store reference": "fluss.canvas.bpmn.element.data_store_reference",
    "Default flow": "fluss.canvas.bpmn.element.default_flow",
    "Empty pool/participant": "fluss.canvas.bpmn.element.empty_pool_participant",
    "End event": "fluss.canvas.bpmn.element.end_event",
    "Error boundary event": "fluss.canvas.bpmn.element.error_boundary_event",
    "Error end event": "fluss.canvas.bpmn.element.error_end_event",
    "Error start event": "fluss.canvas.bpmn.element.error_start_event",
    "Escalation boundary event (non-interrupting)": "fluss.canvas.bpmn.element.escalation_boundary_event_non_interrupting",
    "Escalation boundary event": "fluss.canvas.bpmn.element.escalation_boundary_event",
    "Escalation end event": "fluss.canvas.bpmn.element.escalation_end_event",
    "Escalation intermediate throw event": "fluss.canvas.bpmn.element.escalation_intermediate_throw_event",
    "Escalation start event (non-interrupting)": "fluss.canvas.bpmn.element.escalation_start_event_non_interrupting",
    "Escalation start event": "fluss.canvas.bpmn.element.escalation_start_event",
    "Event based instantiating Gateway": "fluss.canvas.bpmn.element.event_based_instantiating_gateway",
    "Event sub-process": "fluss.canvas.bpmn.element.event_sub_process",
    "Event-based gateway": "fluss.canvas.bpmn.element.event_based_gateway",
    "Exclusive gateway": "fluss.canvas.bpmn.element.exclusive_gateway",
    "Expanded pool/participant": "fluss.canvas.bpmn.element.expanded_pool_participant",
    "Inclusive gateway": "fluss.canvas.bpmn.element.inclusive_gateway",
    "Intermediate throw event": "fluss.canvas.bpmn.element.intermediate_throw_event",
    "Link intermediate catch event": "fluss.canvas.bpmn.element.link_intermediate_catch_event",
    "Link intermediate throw event": "fluss.canvas.bpmn.element.link_intermediate_throw_event",
    "Manual task": "fluss.canvas.bpmn.element.manual_task",
    "Message boundary event (non-interrupting)": "fluss.canvas.bpmn.element.message_boundary_event_non_interrupting",
    "Message boundary event": "fluss.canvas.bpmn.element.message_boundary_event",
    "Message end event": "fluss.canvas.bpmn.element.message_end_event",
    "Message intermediate catch event": "fluss.canvas.bpmn.element.message_intermediate_catch_event",
    "Message intermediate throw event": "fluss.canvas.bpmn.element.message_intermediate_throw_event",
    "Message start event (non-interrupting)": "fluss.canvas.bpmn.element.message_start_event_non_interrupting",
    "Message start event": "fluss.canvas.bpmn.element.message_start_event",
    "Parallel Event based instantiating Gateway": "fluss.canvas.bpmn.element.parallel_event_based_instantiating_gateway",
    "Parallel gateway": "fluss.canvas.bpmn.element.parallel_gateway",
    "Receive task": "fluss.canvas.bpmn.element.receive_task",
    "Script task": "fluss.canvas.bpmn.element.script_task",
    "Send task": "fluss.canvas.bpmn.element.send_task",
    "Sequence flow": "fluss.canvas.bpmn.element.sequence_flow",
    "Service task": "fluss.canvas.bpmn.element.service_task",
    "Signal boundary event (non-interrupting)": "fluss.canvas.bpmn.element.signal_boundary_event_non_interrupting",
    "Signal boundary event": "fluss.canvas.bpmn.element.signal_boundary_event",
    "Signal end event": "fluss.canvas.bpmn.element.signal_end_event",
    "Signal intermediate catch event": "fluss.canvas.bpmn.element.signal_intermediate_catch_event",
    "Signal intermediate throw event": "fluss.canvas.bpmn.element.signal_intermediate_throw_event",
    "Signal start event (non-interrupting)": "fluss.canvas.bpmn.element.signal_start_event_non_interrupting",
    "Signal start event": "fluss.canvas.bpmn.element.signal_start_event",
    "Start event": "fluss.canvas.bpmn.element.start_event",
    "Sub-process (collapsed)": "fluss.canvas.bpmn.element.sub_process_collapsed",
    "Sub-process (expanded)": "fluss.canvas.bpmn.element.sub_process_expanded",
    "Sub-process": "fluss.canvas.bpmn.element.sub_process",
    "Task": "fluss.canvas.bpmn.element.task",
    "Terminate end event": "fluss.canvas.bpmn.element.terminate_end_event",
    "Timer boundary event (non-interrupting)": "fluss.canvas.bpmn.element.timer_boundary_event_non_interrupting",
    "Timer boundary event": "fluss.canvas.bpmn.element.timer_boundary_event",
    "Timer intermediate catch event": "fluss.canvas.bpmn.element.timer_intermediate_catch_event",
    "Timer start event (non-interrupting)": "fluss.canvas.bpmn.element.timer_start_event_non_interrupting",
    "Timer start event": "fluss.canvas.bpmn.element.timer_start_event",
    "Transaction": "fluss.canvas.bpmn.element.transaction",
    "User task": "fluss.canvas.bpmn.element.user_task",
    "Align elements": "fluss.canvas.bpmn.action.align_elements",
    "Delete": "fluss.canvas.bpmn.action.delete",
    "Add lane above": "fluss.canvas.bpmn.action.add_lane_above",
    "Divide into two lanes": "fluss.canvas.bpmn.action.divide_into_two_lanes",
    "Divide into three lanes": "fluss.canvas.bpmn.action.divide_into_three_lanes",
    "Add lane below": "fluss.canvas.bpmn.action.add_lane_below",
    "Append receive task": "fluss.canvas.bpmn.action.append_receive_task",
    "Append message intermediate catch event": "fluss.canvas.bpmn.action.append_message_intermediate_catch_event",
    "Append timer intermediate catch event": "fluss.canvas.bpmn.action.append_timer_intermediate_catch_event",
    "Append conditional intermediate catch event": "fluss.canvas.bpmn.action.append_conditional_intermediate_catch_event",
    "Append signal intermediate catch event": "fluss.canvas.bpmn.action.append_signal_intermediate_catch_event",
    "Append compensation activity": "fluss.canvas.bpmn.action.append_compensation_activity",
    "Append end event": "fluss.canvas.bpmn.action.append_end_event",
    "Append gateway": "fluss.canvas.bpmn.action.append_gateway",
    "Append task": "fluss.canvas.bpmn.action.append_task",
    "Append intermediate/boundary event": "fluss.canvas.bpmn.action.append_intermediate_boundary_event",
    "Change element": "fluss.canvas.bpmn.action.change_element",
    "Add text annotation": "fluss.canvas.bpmn.action.add_text_annotation",
    "Connect to other element": "fluss.canvas.bpmn.action.connect_to_other_element",
    "Connect using association": "fluss.canvas.bpmn.action.connect_using_association",
    "Connect using data input association": "fluss.canvas.bpmn.action.connect_using_data_input_association",
    "Distribute elements horizontally": "fluss.canvas.bpmn.action.distribute_elements_horizontally",
    "Distribute elements vertically": "fluss.canvas.bpmn.action.distribute_elements_vertically",
    "Parallel multi-instance": "fluss.canvas.bpmn.action.parallel_multi_instance",
    "Sequential multi-instance": "fluss.canvas.bpmn.action.sequential_multi_instance",
    "Loop": "fluss.canvas.bpmn.action.loop",
    "Collection": "fluss.canvas.bpmn.action.collection",
    "Participant multiplicity": "fluss.canvas.bpmn.action.participant_multiplicity",
    "Ad-hoc": "fluss.canvas.bpmn.action.ad_hoc",
    "Toggle non-interrupting": "fluss.canvas.bpmn.action.toggle_non_interrupting",
};
